export default __webpack_public_path__ + "static/media/zip_code_icon.f66631c6.svg";